import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuthCtx } from '../App';
import { toast } from 'react-toastify';
import Logo from '../components/Logo';
import PasswordInput from '../components/PasswordInput';

export default function LoginPage() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const { login, loading } = useAuthCtx();
  const navigate  = useNavigate();
  const location  = useLocation();

  const dashboardFor = (role) =>
    role === 'admin' ? '/admin' : '/dashboard';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const { user } = await login(email, password);
      toast.success('Welcome back!');
      const dest = location.state?.from || dashboardFor(user.role);
      navigate(dest, { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <div className="min-h-screen bg-tea-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full card">
        <div className="text-center mb-8">
          <Link to="/" aria-label="Aloha Amino home" className="inline-flex items-center">
            <Logo className="text-3xl" />
          </Link>
          <h1 className="mt-4 text-2xl font-bold">Sign in to Aloha Amino</h1>
          <p className="text-gray-500 mt-1">Welcome back, researcher.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="bg-red-50 text-red-700 p-3 rounded-lg text-sm">{error}</div>
          )}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              required className="input-field" placeholder="you@example.com" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <PasswordInput value={password} onChange={e => setPassword(e.target.value)}
              required autoComplete="current-password" />
          </div>
          <div className="flex items-center justify-end">
            <Link to="/forgot-password" className="text-sm text-tea-600 hover:underline">
              Forgot password?
            </Link>
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full py-3">
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <p className="text-center mt-6 text-gray-600 text-sm">
          Don't have an account?{' '}
          <Link to="/register" className="text-tea-600 hover:underline font-medium">Sign up free</Link>
        </p>
      </div>
    </div>
  );
}
